import { useNavigate } from "react-router-dom";
import { Construction } from "@mui/icons-material";

function ProjectItem({ name, image, id, bgOffsetY, inDevelopment }) {
    const navigate = useNavigate()
    return (
        <div className="project-item" onClick={() => {
            navigate("/project/" + id)
        }}>
            <div style={{
                backgroundImage: `url(${image})`,
                backgroundPosition: bgOffsetY ? `center ${bgOffsetY}` : 'center'
            }} className="bgImage">
                <div className="card-glare"></div>
            </div>

            <div className="project-title-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px" }}>
                <h1>{name}</h1>
                {inDevelopment && (
                    <div title="In Development" style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "#ff9800",
                        borderRadius: "50%",
                        padding: "5px",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
                    }}>
                        <Construction style={{ color: "#fff", fontSize: "20px" }} />
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProjectItem